import { render, staticRenderFns } from "./StructControls.vue?vue&type=template&id=6cd89d74"
import script from "./StructControls.vue?vue&type=script&lang=js"
export * from "./StructControls.vue?vue&type=script&lang=js"
import style0 from "./StructControls.vue?vue&type=style&index=0&id=6cd89d74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports